import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const LoadingSpinner = ({ size }) => {
  return (
    <div className="flex items-center justify-center">
      <FontAwesomeIcon
        icon={faSpinner}
        spin
        size={size || "3x"}
        className="text-blue-600"
      />
    </div>
  );
};

export default LoadingSpinner;
